<template>
  <div class="date-picker-cpn">
    <el-date-picker v-model="dateTime[0]"
                    :type="datePickerType"
                    size="mini"
                    :picker-options="pickerOptions"
                    :format="format"
                    :clearable="false"
                    @change="changeDate($event, 'start')"
                    placeholder="选择日期"
                    style="width: 120px"
                    ref="startPicker">
    </el-date-picker>
    <span style="margin: 0 10px">至</span>
    <el-date-picker v-model="dateTime[1]"
                    :type="datePickerType"
                    size="mini"
                    :picker-options="pickerOptions"
                    :format="format"
                    :clearable="false"
                    @change="changeDate($event, 'end')"
                    placeholder="选择日期"
                    style="width: 120px"
                    ref="endPicker">
    </el-date-picker>
  </div>
</template>


<script>
import {
  build_ts,
  build_day_ts,
  build_day,
  parseTime,
  getNearestFullWeek,
} from '@/utils'
import { LuxonTime } from 'common'
export default {
  name: 'DatePicker',
  data() {
    return {
      timeList: [], //所有权限时间数据
      dateTime: ['', ''], //选择器展示数据
      plat: '',
      catTs: [], //当前权限类目的时间范围
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: (time) => this.disabledDate(time),
      },
    }
  },
  props: {
    currentTime: {
      type: Array,
      default: () => ['', ''],
    },
    datePickerType: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    latestTime() {
      return this.$store.state.user.latestTime
    },
    format() {
      if (this.datePickerType == 'month') {
        return 'yyyy-MM'
      } else {
        return 'yyyy-MM-dd'
      }
    },
    // pickerOptions(){
    //     return this.dateTime[0] < this.timeList[0] || this.dateTime[0] > this.timeList[this.timeList.length -1]
    // },
    // pickerOptions2(){
    //     return this.dateTime[1] < this.timeList[0] || this.dateTime[1] > this.timeList[this.timeList.length -1]
    // },
  },
  methods: {
    disabledDate(date) {
      if (this.timeList && this.timeList.length > 0) {
        let time = this.formatDate(date, '{y}-{m}')
        if (this.datePickerType != 'month') {
          time = this.formatDate(date, '{y}-{m}-{d}')
        }
        return (
          //第一项为最大时间，最后一项为最小时间
          time > this.timeList[0] ||
          time < this.timeList[this.timeList.length - 1]
        )
      } else {
        return true
      }
    },
    changeDate(val, type) {
      if (this.datePickerType == 'week') {
        let givenDate = new Date(this.formatDate(val))
        const { startOfWeek, endOfWeek } = this.getStartAndEndOfWeek(givenDate)
        if (type == 'start') {
          this.dateTime[0] = startOfWeek
        }
        if (type == 'end') {
          this.dateTime[1] = endOfWeek
        }
        this.$forceUpdate()
      } else if (this.datePickerType == 'month') {
        if (type == 'start') {
          this.dateTime[0] = this.formatDate(val, '{y}-{m}')
        }
        if (type == 'end') {
          this.dateTime[1] = this.formatDate(val, '{y}-{m}')
        }
      } else if (this.datePickerType == 'date') {
        if (type == 'start') {
          this.dateTime[0] = this.formatDate(val, '{y}-{m}-{d}')
        }
        if (type == 'end') {
          this.dateTime[1] = this.formatDate(val, '{y}-{m}-{d}')
        }
      }
    },
    initMethod() {
      const { platTime } = this.$store.state.user
      const { start, end } = this.$route.query
      if (platTime.start && platTime.end && this.catTs.length == 0) {
        if (this.datePickerType == 'month') {
          this.timeList = build_ts(platTime.end, platTime.start)
        } else {
          if (platTime.start.split('-').length == 2) {
            this.timeList = build_day_ts(platTime.end, platTime.start)
          } else {
            this.timeList = build_day(platTime.end, platTime.start)
          }
        }
        this.dateTime = [start, end]
      }
    },
    getStartAndEndOfWeek(date) {
      const day = date.getDay()
      const diff = date.getDate() - day + (day === 0 ? -6 : 1) // 考虑周日的情况

      const startDate = new Date(date)
      startDate.setDate(diff)

      const endDate = new Date(date)
      endDate.setDate(diff + 6)

      // 格式化日期
      const formattedStartDate = startDate.toISOString().split('T')[0]
      const formattedEndDate = endDate.toISOString().split('T')[0]

      return {
        startOfWeek: formattedStartDate,
        endOfWeek: formattedEndDate,
      }
    },
    formatDate(date, cFormat) {
      const format = cFormat || '{y}-{m}-{d}'
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const formatObj = {
        y: year,
        m: month,
        d: day,
      }
      const time_str = format.replace(/{([ymd])+}/g, (result, key) => {
        const value = formatObj[key]
        return value.toString()
      })
      return time_str
    },
    setPopperClass() {
      let startUnwatch = null,
        endUnwatch = null
      // 监听活动日历 年份发生变化后2023年以前的数据需要tip提示
      this.$nextTick(() => {
        const startPicker = this.$refs.startPicker // 获取组件
        const endPicker = this.$refs.endPicker // 获取组件
        // pickerVisible为true时picker才展示出来
        startPicker.$watch('pickerVisible', (newValue) => {
          if (newValue) {
            // 打开了日期选择面板，获取picker组件
            const picker = startPicker.picker
            if (picker) {
              startUnwatch = picker.$watch('date', (newDate) => {
                const year = Number(this.formatDate(newDate, '{y}'))
                if (!Number.isNaN(year) && year <= 2023) {
                  picker.popperClass = 'commentDatePickerPopper'
                } else {
                  picker.popperClass = ''
                }
              })
            }
          } else {
            if (startUnwatch) {
              // 移除监听效果 防止重复监听 多次触发回调
              startUnwatch()
            }
          }
        })
        endPicker.$watch('pickerVisible', (newValue) => {
          if (newValue) {
            // 打开了日期选择面板，获取picker组件
            const picker = endPicker.picker
            if (picker) {
              endUnwatch = picker.$watch('date', (newDate) => {
                const year = Number(this.formatDate(newDate, '{y}'))
                if (!Number.isNaN(year) && year <= 2023) {
                  picker.popperClass = 'commentDatePickerPopper'
                } else {
                  picker.popperClass = ''
                }
              })
            }
          } else {
            if (endUnwatch) {
              // 移除监听效果 防止重复监听 多次触发回调
              endUnwatch()
            }
          }
        })
      })
    },
  },
  created() {
    this.init = _.debounce(this.initMethod, 300)
  },
  mounted() {
    if (this.$store.state.user.platTime.start) {
      this.init()
    }
    this.setPopperClass()
  },
  watch: {
    '$route.query': {
      handler(newVal, oldVal) {
        if (newVal.plat && oldVal.plat !== newVal.plat) {
          this.plat = newVal.plat
        }
        if (newVal.start) {
          this.dateTime = [newVal.start, newVal.end]
        }
        // this.init()
      },
    },
    '$store.state.user.platTime': {
      handler(value) {
        this.init()
      },
    },
    dateTime(value) {
      this.$emit('on-changeDateTime', value)
    },
    datePickerType: {
      handler(newVal, oldVal) {
        if (this.$route.path == '/catsheetnew') {
          const { platTime, start, end } = this.$store.state.user
          if (platTime.start && platTime.end) {
            if (newVal == 'month') {
              this.timeList = build_ts(platTime.end, platTime.start)
              this.dateTime = [this.timeList[0], this.timeList[0]]
            } else if (newVal == 'week') {
              if (platTime.start.split('-').length == 2) {
                this.timeList = build_day_ts(platTime.end, platTime.start)
              } else {
                this.timeList = build_day(platTime.end, platTime.start)
              }
              const time = getNearestFullWeek(this.timeList[0])
              this.dateTime[0] = time.start
              this.dateTime[1] = time.end
            } else {
              if (platTime.start.split('-').length == 2) {
                this.timeList = build_day_ts(platTime.end, platTime.start)
              } else {
                this.timeList = build_day(platTime.end, platTime.start)
              }
              this.dateTime = [this.timeList[0], this.timeList[0]]
            }
          }
          if (start != this.dateTime[0]) {
            this.$store.dispatch('user/changeStart', this.dateTime[0])
          }
          if (end != this.dateTime[1]) {
            this.$store.dispatch('user/changeEnd', this.dateTime[1])
          }
          //   this.$store.dispatch('user/changeActivedTab', 'Summary')
          //   this.$eventBus.$emit('carSheetReload', true)
        } else if (this.$route.path == '/contrastAnalysis') {
          {
            const { platTime, start, end } = this.$store.state.user
            if (platTime.start && platTime.end) {
              if (newVal == 'month') {
                this.timeList = build_ts(platTime.end, platTime.start)
                this.dateTime = [this.timeList[0], this.timeList[0]]
              } else if (newVal == 'week') {
                if (platTime.start.split('-').length == 2) {
                  this.timeList = build_day_ts(platTime.end, platTime.start)
                } else {
                  this.timeList = build_day(platTime.end, platTime.start)
                }
                const time = getNearestFullWeek(this.timeList[0])
                this.dateTime[0] = time.start
                this.dateTime[1] = time.end
              } else {
                if (platTime.start.split('-').length == 2) {
                  this.timeList = build_day_ts(platTime.end, platTime.start)
                } else {
                  this.timeList = build_day(platTime.end, platTime.start)
                }
                this.dateTime = [this.timeList[0], this.timeList[0]]
              }
            }
            if (start != this.dateTime[0]) {
              this.$store.dispatch('user/changeStart', this.dateTime[0])
            }
            if (end != this.dateTime[1]) {
              this.$store.dispatch('user/changeEnd', this.dateTime[1])
            }
          }
        }
      },
    },
  },
}
</script>

<style lang="less" scoped>
.w120 {
  width: 120px;
}
</style>
<style lang="less">
.date-picker-cpn {
  .el-input--suffix .el-input__inner {
    padding-right: 10px;
  }
}
</style>
